import React, { useState } from 'react';
import { motion } from 'framer-motion';
import AppShortcutEdit from './AppShortcutEdit';

function getHostname(url) {
  try {
    return new URL(url).hostname;
  } catch {
    return null;
  }
}

function AppShortcut({ app, section, index = 0, editMode = false, onEdit, onMove, onDelete, onSaveForLater }) {
  const [faviconFailed, setFaviconFailed] = useState(false);
  const hostname = getHostname(app.url);
  const showFavicon = hostname && !faviconFailed;

  const icon = showFavicon ? (
    <img
      className="app-favicon"
      src={`https://www.google.com/s2/favicons?domain=${hostname}&sz=64`}
      alt=""
      width="24"
      height="24"
      loading="lazy"
      onError={() => setFaviconFailed(true)}
      onLoad={(event) => {
        if (event.currentTarget.naturalWidth <= 16) setFaviconFailed(true);
      }}
    />
  ) : (
    <span className="app-icon" aria-hidden="true">
      {(app.name || '?').trim().charAt(0).toUpperCase()}
    </span>
  );

  if (editMode) {
    return (
      <AppShortcutEdit
        app={app}
        section={section}
        icon={icon}
        onEdit={onEdit}
        onMove={onMove}
        onDelete={onDelete}
        onSaveForLater={onSaveForLater}
      />
    );
  }

  return (
    <motion.a
      className="app-shortcut"
      href={app.url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Open ${app.name} in a new tab`}
      initial={{ opacity: 0, y: 5 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.28, delay: index * 0.035, ease: 'easeOut' }}
      whileTap={{ scale: 0.985 }}
    >
      {icon}
      <span className="app-name">{app.name}</span>
      <span className="shortcut-arrow" aria-hidden="true">↗</span>
    </motion.a>
  );
}

export default AppShortcut;